export default {"src":"/_next/static/media/notification-icon.dd9a4853.svg","height":100,"width":100};